import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { DatePipe } from '@angular/common';

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class YearlyReportDataService {

  constructor(private http: HttpClient) { }

  async GetReportData(id, fromDate, toDate) {
    try {
      let response = await this.http
        .get(`${appApiResources.receiptReport}?offering_type_id=${id}&fromDate=${fromDate}&toDate=${toDate}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  async generateExcel(reportData) {

    //Excel Title, Header, Data
    const title = 'Yearly Report';
    const header = ["Sno", "Partner Id", "Full Name", "Mobile Number", "State", "Year", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    let data = []
    let value = reportData
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        const element = value[key];
        let i = parseInt(key)
        var val = 0
        var name1
        let name = val == 0 ? i != 0 ? value[i - 1].FULL_NAME : "" : name1
        if ((i != 0) && name == value[i].FULL_NAME) {
          name1 = value[i].FULL_NAME
          val = 1
          data.push([
            parseInt(key) + 1,
            "",
            "",
            "",
            "",
            element.year != "" ? parseInt(element.year) : 0,
            element.Jan != "" ? parseInt(element.Jan) : 0,
            element.Feb != "" ? parseInt(element.Feb) : 0,
            element.Mar != "" ? parseInt(element.Mar) : 0,
            element.Apr != "" ? parseInt(element.Apr) : 0,
            element.May != "" ? parseInt(element.May) : 0,
            element.Jun != "" ? parseInt(element.Jun) : 0,
            element.Jul != "" ? parseInt(element.Jul) : 0,
            element.Aug != "" ? parseInt(element.Aug) : 0,
            element.Sep != "" ? parseInt(element.Sep) : 0,
            element.Oct != "" ? parseInt(element.Oct) : 0,
            element.Nov != "" ? parseInt(element.Nov) : 0,
            element.Dec != "" ? parseInt(element.Dec) : 0,
          ])
        } else {
          val = 0
          data.push([
            parseInt(key) + 1,
            element.PARTNER_ID != "" ? parseInt(element.PARTNER_ID) : "",
            element.FULL_NAME,
            element.primary_mobile_no != "" ? parseInt(element.primary_mobile_no) : "",
            element.STATE_NAME,
            element.year != "" ? parseInt(element.year) : 0,
            element.Jan != "" ? parseInt(element.Jan) : 0,
            element.Feb != "" ? parseInt(element.Feb) : 0,
            element.Mar != "" ? parseInt(element.Mar) : 0,
            element.Apr != "" ? parseInt(element.Apr) : 0,
            element.May != "" ? parseInt(element.May) : 0,
            element.Jun != "" ? parseInt(element.Jun) : 0,
            element.Jul != "" ? parseInt(element.Jul) : 0,
            element.Aug != "" ? parseInt(element.Aug) : 0,
            element.Sep != "" ? parseInt(element.Sep) : 0,
            element.Oct != "" ? parseInt(element.Oct) : 0,
            element.Nov != "" ? parseInt(element.Nov) : 0,
            element.Dec != "" ? parseInt(element.Dec) : 0,
          ])
        }

      }
    }
    //Create workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Trending Report', { views: [{ state: 'frozen', xSplit: 1, ySplit: 1 }] });
    //Add Row and formatting
    // let titleRow = worksheet.addRow([title]);
    // titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, underline: 'double', bold: true }
    // worksheet.addRow([]);
    // let subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')])
    // //Add Image
    // let logo = workbook.addImage({
    //   base64: logoFile.logoBase64,
    //   extension: 'png',
    // });
    // worksheet.addImage(logo, 'E1:F3');
    // worksheet.mergeCells('A1:D2');
    //Blank Row 
    //Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    worksheet.addRows(data);
    worksheet.eachRow(function (row, _rowNumber) {
      row.eachCell(function (cell, _colNumber) {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    // Add Data and Conditional Formatting
    // data.forEach(d => {
    //   let row = worksheet.addRow(d);
    //   let qty = row.getCell(5);
    //   let color = 'FF99FF99';
    //   if (+qty.value < 500) {
    //     color = 'FF9999'
    //   }
    //   qty.fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: color }
    //   }
    // }
    // );
    // worksheet.getColumn(3).width = 30;
    // worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);
    //Footer Row
    let footerRow = worksheet.addRow(['This is system generated excel sheet.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'Yearly_Report.xlsx');
    })
  }

}

